import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import Team from "./Team";
import Testimonial from "../Components/Testimonial";
import Footer from "../Components/Footer";
import Chosseus from "../Components/Chosseus";
import { CartProvider } from "react-use-cart";

function Aboute() {
  return (
    <CartProvider>
      <Navbar />
      <Hero value={<h1>Aboute Us</h1>} />
      <Chosseus />
      <Team />
      <Testimonial />
      <Footer />
    </CartProvider>
  );
}

export default Aboute;
